import { useTabFocus } from "hooks/use-tab-focus/use-tab-focus";
import { useEffect, useRef } from "react";

export const useReRunOnTabFocus = (
  cb: () => void,
  { enabled } = { enabled: true }
): void => {
  const hasFocus = useTabFocus();
  const prevTabFocus = useRef(true);

  useEffect(() => {
    if (hasFocus && prevTabFocus.current === false && enabled) {
      // focus has returned to the tab
      cb();
    }
    prevTabFocus.current = hasFocus;
  }, [hasFocus, enabled]);
};
